import { StatusIndicator } from '@strata/react-status-indicators';
import PropTypes from 'prop-types';

export const FaxStatusIndicator = ({
    canSendFax = false,
    faxPrefOptionValue = undefined,
    faxStatus = undefined,
}) => {
    const faxEnabled = faxPrefOptionValue === 'ON';

    return canSendFax ? (
        <StatusIndicator
            message={faxEnabled ? faxStatus?.message : 'NOT ENABLED'}
            status={
                faxEnabled
                    ? StatusIndicator.Status[faxStatus?.status]
                    : StatusIndicator.Status.DEFAULT
            }
            tooltipText={
                faxEnabled
                    ? faxStatus?.tooltip
                    : 'Prescriber fax is not enabled for this payer segment'
            }
        />
    ) : (
        <StatusIndicator
            message="CAN'T SEND"
            status={StatusIndicator.Status.CAUTION}
            tooltipText="Fax number doesn't exist."
        />
    );
};

FaxStatusIndicator.propTypes = {
    canSendFax: PropTypes.bool,
    faxPrefOptionValue: PropTypes.string,
    faxStatus: PropTypes.shape({
        message: PropTypes.string,
        status: PropTypes.string,
        date_sent: PropTypes.string,
        tooltip: PropTypes.string,
    }),
};
